var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pop"},[_c('el-tooltip',{attrs:{"placement":"top","trigger":"hover","content":_vm.content,"close-delay":0,"width":"20px"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }